import { Pipe, PipeTransform } from '@angular/core';
import { NewPaypalTransactionModel } from '../models/NewPaypalTransaction.model';

@Pipe({
  name: 'searchPaypalTransactionHistory'
})
export class SearchPaypalTransactionHistoryPipe implements PipeTransform {

  transform(LogData: NewPaypalTransactionModel[], searchTermPayPalTransaction: string): NewPaypalTransactionModel[] {
    if (!LogData || !searchTermPayPalTransaction) { return LogData; }

    LogData.forEach(element => {
      if (element.date == null) {
        element.date = "";
      }

      if (element.name == null) {
        element.name = "";
      }

      if (element.payment == null) {
        element.payment = "";
      }



      if (element.productName == null) {
        element.productName = "";
      }








    });


    return LogData.filter(ad =>



      ad.date.toLowerCase().indexOf(searchTermPayPalTransaction.toLowerCase().trim()) !== -1
      ||
      ad.name.toLowerCase().indexOf(searchTermPayPalTransaction.toLowerCase().trim()) !== -1
      ||
      ad.payment.toLowerCase().indexOf(searchTermPayPalTransaction.toLowerCase().trim()) !== -1
      ||
      ad.productName.toLowerCase().indexOf(searchTermPayPalTransaction.toLowerCase().trim()) !== -1




    );


  }

}
